import React from 'react'
import { Link } from 'react-router-dom'
import { GoBackLink } from './GoBackLink'
import { Table } from 'react-bootstrap'

export const LmsSelection = () => {
  return (
    <div className="container" style={{ width: '100%' }}>
      <div className="mb-2 go-back-button-left-align">
        <GoBackLink to="/account/admin_homepage/" external />
      </div>
      <div className="card-myed">
        <h3>Supported LMS Platforms:</h3>
        <div className="table-responsive">
        <Table striped bordered className="table-sm" hover>
          <colgroup>
            <col style={{ width: '40%' }} />
            <col style={{ width: '40%' }} />
            <col style={{ width: '20%' }} />
          </colgroup>
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Go To</th>
            </tr>
          </thead>
          <tbody>
            {[
              { name: 'Blackboard', code: 'blackboard' },
              { name: 'Brightspace', code: 'desire2learn' },
              { name: 'Canvas', code: 'canvas' },
              { name: 'Moodle', code: 'moodle' },
            ].map(lms => (
              <tr key={lms.code}>
                <td>{lms.name}</td>
                <td>{lms.code}</td>
                <td>
                  <Link
                    to={`/account/admin_lti13/-/platforms/${lms.code}/issuers`}
                  >
                    View Issuers
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      </div>
      <div className="card-myed mt-3">
        <h3>Other:</h3>
        <div className="table-responsive">
        <Table striped bordered className="table-sm" hover>
          <colgroup>
            <col style={{ width: '40%' }} />
            <col style={{ width: '40%' }} />
            <col style={{ width: '20%' }} />
          </colgroup>
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Go To</th>
            </tr>
          </thead>
          <tbody>
            {[
              { name: 'MyEducator Internal', code: 'myed' },
              { name: 'All Platforms (Issuers)', code: 'all' },
            ].map(lms => (
              <tr key={lms.code}>
                <td>{lms.name}</td>
                <td>{lms.code}</td>
                <td>
                  <Link
                    to={`/account/admin_lti13/-/platforms/${lms.code}/issuers`}
                  >
                    View Issuers
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      </div>
    </div>
  )
}
